import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do commercial roofers reach property managers and GCs?",
    "a": "B2B-positioned sites with project case studies, bonding info, certifications, and bid-request workflows. PMs evaluate differently than homeowners. The site has to read PM, not residential."
  },
  {
    "q": "Is SEO worth it for commercial-only roofing?",
    "a": "Yes — 'commercial roofer', 'TPO contractor', 'commercial roof replacement' have stable, high-value search volume from PMs and facilities. One commercial project covers a year of SEO."
  },
  {
    "q": "Should commercial roofers run Google Ads?",
    "a": "Yes — properly targeted to commercial keywords only. Without negative keyword work, ads bleed into residential searches and waste budget."
  },
  {
    "q": "Do you market for re-roofing vs new construction?",
    "a": "Yes — each has different decision-makers and different content needs. Re-roof pages target PMs; new construction pages target GCs and developers."
  },
  {
    "q": "How important are case studies?",
    "a": "Decisive. PMs evaluate by similar-project proof. We build out case study libraries by building type and roof system."
  }
];

export const Route = createFileRoute("/commercial-roofing-marketing-colorado")({
  head: () =>
    industryMarketingHead("Commercial Roofing", "commercial roofing contractor", "commercial-roofing-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Commercial Roofing"}
      industryLower={"commercial roofing contractor"}
      slug={"commercial-roofing-marketing-colorado"}
      subheadline={"We help Colorado commercial roofing contractors win property manager, GC, and facilities decision-maker work — not residential storm chasing."}
      painPoints={["Your site reads residential and PMs scroll past","Storm-chasing competitors confuse the market and drive down quote quality","You don't show up for 'commercial roofer' searches in your own city"]}
      serviceDescriptions={{
        seo: "Rank for commercial roofing, TPO, EPDM, metal roof, roof replacement, and every commercial service across every Colorado market.",
        googleMaps: "Own 'commercial roofer near me' in the Map Pack with PM and GC-focused review signals.",
        webDesign: "B2B sites with project case studies, certifications, bonding info, and bid-request workflows tuned for PMs.",
        ppc: "Profitable Google Ads tuned to PM and GC search behavior — not residential storm-chase keywords.",
        geoAi: "Get cited when PMs ask ChatGPT 'best commercial roofer in Denver' or 'TPO contractor near me'.",
        socialMedia: "B2B content — project case studies and certifications — that builds trust with decision-makers.",
      }}
      testimonial={{"quote":"We stopped competing with storm-chase residential outfits and the bid pipeline shifted entirely to repeat PM and GC work.","role":"Owner, Commercial Roofing Company","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Commercial roofing marketing in Colorado Springs","description":"Reach PMs and facilities decision-makers across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Commercial roofing marketing in Denver","description":"Win PM and GC roofing work across Denver's commercial market."},{"to":"/boulder-digital-marketing","label":"Commercial roofing marketing in Boulder","description":"Commercial and institutional roofing across Boulder County."}]}
    />
  ),
});
